import { Link as ChakraLink, Text } from "@chakra-ui/react";
import React from "react";
import { Link } from "wouter";

interface BreadcrumbsProps {
  crumbs: {
    label: string;
    href: string;
  }[];
}

export function Breadcrumbs({ crumbs }: BreadcrumbsProps) {
  return (
    <Text p={4} w="100%" bgColor="bij12_2.700" color="white" fontSize={20}>
      {crumbs.map((crumb, idx) => (
        <React.Fragment key={`${idx}`}>
          <Link href={crumb.href}>
            <ChakraLink
              href={crumb.href}
              color="white"
              fontWeight="bold"
              fontSize={20}
              textTransform="uppercase"
            >
              {crumb.label}
            </ChakraLink>
          </Link>
          {idx < crumbs.length - 1 ? " - " : ""}
        </React.Fragment>
      ))}
    </Text>
  );
}
